import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  themeMode: '',
  themeColor: '',
  borderStroke: '',
  boxLayout: '',
  borderRadius: '',
  iconColor: '',
  gradientColor: '',
  monochrome: '',
};

const themeSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setThemeMode: (state, action) => {
      state.themeMode = action.payload;
    },
    setThemeColor: (state, action) => {
      state.themeColor = action.payload;
    },
    setBorderStroke: (state, action) => {
      state.borderStroke = action.payload;
    },
    setBodyGradient: (state, action) => {
      state.gradientColor = action.payload;
    },
    setBoxLayout: (state, action) => {
      state.boxLayout = action.payload;
    },
    setMonoChrome: (state, action) => {
      state.monochrome = action.payload;
    },
    setBorderRadius: (state, action) => {
      state.borderRadius = action.payload;
    },
    setIconColor: (state, action) => {
      state.iconColor = action.payload;
    },
  },
});

export const {
  setThemeMode,
  setThemeColor,
  setBorderStroke,
  setBodyGradient,
  setBoxLayout,
  setMonoChrome,
  setBorderRadius,
  setIconColor,
} = themeSlice.actions;

export default themeSlice.reducer;
